import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import createGuid from "terriajs-cesium/Source/Core/createGuid";
import CommonStrata from "../../Models/Definition/CommonStrata";
import ChartCustomComponent from "./ChartCustomComponent";
export default class SOSChartCustomComponent extends ChartCustomComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "constructShareableCatalogItem", async (_id, context, _sourceReference) => this.createItemReference(context.catalogItem));
  }
  get name() {
    return "sos-chart";
  }
  get attributes() {
    const attributes = super.attributes;
    attributes.push("name");
    return attributes;
  }
  constructCatalogItem(_id, context, _sourceReference) {
    var _context$catalogItem;
    return (_context$catalogItem = context.catalogItem) === null || _context$catalogItem === void 0 ? void 0 : _context$catalogItem.duplicateModel(createGuid());
  }
  setTraitsFromAttrs(item, attrs, _sourceIndex) {
    var _item$selectedObserva, _item$addObject;
    const featureOfInterestId = attrs.identifier;
    const featureName = attrs.name;
    const units = (_item$selectedObserva = item.selectedObservable) === null || _item$selectedObserva === void 0 ? void 0 : _item$selectedObserva.units;
    item.setTrait(CommonStrata.user, "showAsChart", true);
    item.setTrait(CommonStrata.user, "name", featureName || item.name);
    item.setTrait(CommonStrata.user, "chartFeatureOfInterestIdentifier", featureOfInterestId);
    (_item$addObject = item.addObject(CommonStrata.user, "columns", "values")) === null || _item$addObject === void 0 || _item$addObject.setTrait(CommonStrata.user, "units", units);
  }
  parseNodeAttrs(nodeAttrs) {
    const parsed = super.parseNodeAttrs(nodeAttrs);
    parsed.name = nodeAttrs["name"];
    return parsed;
  }
}